import { Helmet } from 'react-helmet';
import React, {useEffect,useState, useRef } from 'react'
import ProductPost from '../components/ProductPost';
import { useAuth } from '../Context/AuthContext';
const Utility=require('../Utility/Utilty');



export default function Shop( ) {
    const [Products, setProducts] = useState([]);
    const [UID, setUserID] = useState('');
    const util= new Utility();
    const {authUser, isLoggedIn, countItems, UpdateBagCount ,setAuthUser ,setIsLoggedIn } =useAuth();
    

    useEffect(() => {       
        //setUserID(authUser.ID);
        console.log("ShopUID-i:",authUser.ID);    
    }, [authUser]);

    useEffect(() => {
        console.log("ShopUID-f:",authUser.ID);    
    }, [authUser]);


    useEffect(() => {
        // Fetch newProducts when the component mounts
    //console.log("HomeUID-i:",userID);
    //setUserID(userID);

        fetch('/listProducts?filter=InStockQ>0')
            .then(response => response.json())
            .then(data => setProducts(data))  
            .catch(error => console.error('Error fetching Products:', error));
    }, [authUser]); // Empty dependency array ensures the effect runs only once
    
 
    // Divide Products into arrays of 4 products each
    const chunkedProducts = [];
    const chunkSize = 4;
    for (let i = 0; i < Products.length; i += chunkSize) {
        chunkedProducts.push(Products.slice(i, i + chunkSize));
    }
    
  return (
    <>
        
    <Helmet>
        <title>Catalog</title>
        <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
    <style>{`
        #mstd-1 {
        width: 50%;
        height: 100%;
        background: url('assets/imgs/f2.jpg');
        background-position: center;
        background-repeat: no-repeat;
        background-attachment: scroll;
        background-size: cover;
        }

        #mstd-2 {
        width: 50%;
        height: 100%;
        background-image: url('assets/imgs/f1.jpg');
        background-position: center;
        background-repeat: no-repeat;
        background-attachment: scroll;
        background-size: cover;
        }

        .msg-box {
        display: grid;
        padding: 0.75rem;
        overflow: hidden;
        height: 10vh;
        font-size: xx-small;
        }

        .msg-r {
        width: 25%;
        margin-right: 1.5%;
        justify-self: flex-end;
        }

        .msg-l {
        width: 25%;
        margin-left: 3.5%;
        justify-self: flex-start;
        }

        .mstd-banner {
        height: 50vh;
        width: 100%;
        background: url(assets/imgs/1080pxframe.jpg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        }

        #shop-new-post {
        display: flex;
        margin: auto;
        }

        #hanger-img {
        margin-top: 6vh;
        margin-left: 20vh;
        transform: rotate(20deg);
        }

        #pol-3 .shop-post {
        width: auto;
        min-width: auto;
        }

        @media (min-width: 500px) {
        #hanger {
            float: right;
        }
        }

        .shop-post {
            width: 25%;
            min-width: 25vh;
            height: 40vh;
            background-color: rgba(245, 245, 245, 0.815);
            margin: 0.35rem
        }

        .animate-scroll {
        animation: scrollRow 3s infinite alternate;
        }

        @keyframes scrollRow {
        from {
            transform: translateX(0);
        }
        to {
            transform: translateX(100%);
        }
        }

        .shop-post-row {
        overflow-x: scroll;
        overflow-y: hidden;
        display: flex;
        scroll-behavior: smooth;
        margin-bottom: 1rem;
        }

        .shop-post-row .shop-post {
           
        }
    `}</style>
    </Helmet>

    <section id="Shop" style={{ display: 'flex',  justifyContent: 'center', padding: '1vh' , flexWrap: 'wrap' }}>
      
        <div style={{ width: '100%', textAlign: 'center', marginTop: '5vh' }} >
            <hr style={{ width: '35%', border: '1px solid rgba(192, 192, 192, 0.20)', marginBottom: '1.5vh' }}/>
            <h4>Catalog</h4>

            <>
            {/* Map over the chunkedProducts array */}
            {chunkedProducts.map((chunk, index) => (
                <div key={`shop-post-row-${index + 1}`} className="shop-post-row d-flex mx-auto">
                {chunk.map((product) => (
                    <ProductPost
                        key={product.ID}
                        productID={product.ID}
                        description={product.Description}
                        priceVal={product.Price}
                        discount={product.Discount}
                        sizesAvail="[L][M][S]"
                        imgSrc={util.getImageUrl(product.ImageType0, product.Image0)}
                        UserID={authUser.ID}                   
                    />

                    
                ))}
                </div>
            ))}
            </>

           
        </div>


    </section>





      
    </>
  )
}
